export default __webpack_public_path__ + "static/media/burger.03348c81.svg";